/* Full-screen mobile navigation: native details fallback, keyboard and scroll management. */
(() => {
  const mobile = matchMedia('(max-width: 1099px)');
  let active = null;
  let inertElements = [];
  function unlock() {
    inertElements.forEach(([element, previous]) => { element.inert = previous; });
    inertElements = [];
    document.documentElement.classList.remove('bw-menu-open');
    active = null;
  }
  function initialize(root = document) {
    const headers = [...(root.matches?.('.bw-header-section') ? [root] : []), ...root.querySelectorAll('.bw-header-section')];
    headers.forEach(header => {
      if (header.dataset.bwStickyReady) return;
      header.dataset.bwStickyReady = 'true';
      const rail = header.querySelector('[data-bw-header-rail]');
      const slot = rail?.parentElement;
      if (!rail || !slot) return;
      let frame = 0;
      const update = () => {
        frame = 0;
        const main = document.getElementById('MainContent') || document.querySelector('main');
        const first = main?.firstElementChild;
        const hero = first?.matches('.bw-hero-full') ? first : first?.querySelector('.bw-hero-full');
        const overHero = Boolean(hero);
        header.classList.toggle('bw-header-over-hero', overHero);
        const height = rail.getBoundingClientRect().height;
        slot.style.height = overHero ? '0px' : height + 'px';
        document.documentElement.style.setProperty('--bw-header-height', height + 'px');
        const announcements = header.querySelector('.bw-header-announcements');
        document.documentElement.style.setProperty('--bw-announcement-height', (announcements?.getBoundingClientRect().height || 0) + 'px');
        rail.classList.toggle('is-fixed', slot.getBoundingClientRect().top <= 0);
        rail.classList.toggle('is-transparent', overHero && window.scrollY <= 4);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      header.bwHeaderUpdate = update;
      window.addEventListener('scroll', schedule, {passive:true});
      window.addEventListener('resize', schedule, {passive:true});
      if ('ResizeObserver' in window) {header.bwSizeObserver = new ResizeObserver(schedule);header.bwSizeObserver.observe(rail);}
      header.bwStickyCleanup = () => {
        cancelAnimationFrame(frame);
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        header.bwSizeObserver?.disconnect();
      };
      update();

    });
    root.querySelectorAll('[data-bw-site-menu]').forEach(menu => {
      if (menu.dataset.bwNavigationReady) return;
      menu.dataset.bwNavigationReady = 'true';
      const trigger = menu.querySelector('summary');
      const panel = menu.querySelector('.bw-menu-panel');
      const close = menu.querySelector('[data-bw-menu-close]');
      function sync() {
        trigger.setAttribute('aria-expanded', String(menu.open));
        if (menu.open && mobile.matches) {
          if (active && active !== menu) active.open = false;
          unlock();
          active = menu;
          document.documentElement.classList.add('bw-menu-open');
          // Keep the header's ancestors interactive. Hide their unrelated siblings from focus.
          let branch = menu;
          while (branch.parentElement && branch !== document.body) {
            [...branch.parentElement.children].filter(el => el !== branch && !['SCRIPT','STYLE','LINK','TEMPLATE'].includes(el.tagName)).forEach(el => {
              inertElements.push([el, el.inert]);el.inert = true;
            });
            branch = branch.parentElement;
          }
          close.focus({preventScroll:true});
        } else if (active === menu) {
          unlock();
          if (mobile.matches && menu.isConnected) trigger.focus({preventScroll:true});
        }
      }
      menu.addEventListener('toggle', sync);
      close.addEventListener('click', () => { menu.open = false;sync(); });
      menu.addEventListener('keydown', event => {
        if (!menu.open || !mobile.matches) return;
        if (event.key === 'Escape') {event.preventDefault();menu.open = false;sync();return;}
        if (event.key !== 'Tab') return;
        const focusable = [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length);
        const first = focusable[0], last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
        else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
      });
      mobile.addEventListener('change', () => {if (!mobile.matches && menu.open) {menu.open=false;sync();}});
      sync();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => {initialize(event.target);document.querySelectorAll('.bw-header-section').forEach(header => header.bwHeaderUpdate?.());});
  document.addEventListener('shopify:section:unload', event => {if (active && event.target.contains(active)) unlock();event.target.bwStickyCleanup?.();});
})();
